import React, { useCallback, useEffect, useState } from "react";
import Header from "../Header/header";
import StepperHeader from "./StepperHeader";
import AddTreatmentID from "./AddTreatmentID";
import PatientDetails from "./PatientDetails";
import CreateConsentEmail from "./CreateConsentEmail";
import ConfirmAndSend from "./ConfirmAndSend";
import styles from "./flow.module.scss";
import { useLocation } from "react-router-dom";

const steps = [
  { label: "Add treatment ID", sub: "Add the treatment ID to the associated clinician.", component: AddTreatmentID },
  { label: "Patient details", sub: "All patient details are auto-fetched from Dentally.", component: PatientDetails },
  { label: "Create consent email", sub: "Complete the consent email, add media and signatures.", component: CreateConsentEmail },
  { label: "Confirm and send", sub: "Confirm and send consent to patients.", component: ConfirmAndSend },
];

export default function TreatmentFlow() {
  const [activeStep, setActiveStep] = useState(0);
  const [treatmentData, setTreatmentData] = useState(null);
  const location = useLocation();


  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const stepIndex = Number(params.get("step"));
  const stored = sessionStorage.getItem("activeTreatmentData");

  if (stored) {
    setTreatmentData(JSON.parse(stored));
    sessionStorage.removeItem("activeTreatmentData");
  }

  if (!isNaN(stepIndex)) {
    setActiveStep(stepIndex);
  }
}, [location]);

  const goNext = useCallback(() => setActiveStep((s) => Math.min(s + 1, steps.length - 1)), []);
  const goBack = useCallback(() => setActiveStep((s) => Math.max(s - 1, 0)), []);

  const StepComponent = steps[activeStep].component;

  return (
    <div className={styles.flowPage}>
      <Header />
      <div className={styles.flowContainer}>
        <StepperHeader steps={steps} activeStep={activeStep} />
        <div className={styles.flowSection}>
          <header className={styles.flowHeader}>
            <h1 className={styles.flowTitle}>{steps[activeStep].label}</h1>
            <p className={styles.flowDesc}>{steps[activeStep].sub}</p>
          </header>
          <div>
            <StepComponent
              key={activeStep}
              onNext={goNext}
              onBack={goBack}
              treatmentData={treatmentData}
              setTreatmentData={setTreatmentData}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
